import { xlCol, xlColq } from "../../common/constants";
export const dateHeaders = [
  { field: 'fromDate', header: 'From  Date', textAlign: 'left' },
  { field: 'toDate', header: 'To  Date', textAlign: 'left' },
]
export const criteriaHeaders = [
  ...dateHeaders,
  { field: 'selState', header: 'State', textAlign: 'left' },
  { field: 'selCity', header: 'City', textAlign: 'left' },
  { field: 'selBranch', header: 'Branch', textAlign: 'left' },
]
export const profileLossCriteriaHeaders = [
  ...dateHeaders,
  { field: 'vehicle', header: 'Vehicle', textAlign: 'left' },
]
export const BranchDueHeaders = [
  { header: "SN", field: "SN", xlCol: xlCol, weight: 23 },
  { header: "Date", field: "TransDate", xlCol: xlCol, weight: 80 },
  { header: "Branch State", field: "StateName", xlCol: xlCol, weight: 54 },
  { header: "Branch City", field: "CityName", xlCol: xlCol, weight: 100 },
  { header: "Branch Name", field: "BranchName", xlCol: xlCol, weight: 100 },
  {
    header: "Opening \nOutstanding \nReceivable",
    field: "CargoBalance",
    xlCol: xlColq,
    weight: 69,
  },
  {
    header: "On Account \nBookings",
    field: "OnaccAmt",
    xlCol: xlColq,
    weight: 54,
  },
  {
    header: "Paid \nBookings",
    field: "PaidAmt",
    xlCol: xlColq,
    weight: 54,
  },
  {
    header: "To Pay \nDeliveries",
    field: "TopayAmt",
    xlCol: xlColq,
    weight: 54,
  },
  {
    header: "Gross \nBusiness",
    field: "GrossBusiness",
    xlCol: xlColq,
    weight: 54,
  },
  {
    header: "Commission \nPayable",
    field: "Commission_view",
    xlCol: xlColq,
    weight: 54,
  },
  {
    header: "Other Cargo \nExp Payables",
    field: "ExpenseAmt",
    xlCol: xlColq,
    weight: 63,
  },
  {
    header: "Pickup Cartage \n(Door Pickup)",
    field: "PickupCartage",
    xlCol: xlColq,
    weight: 66,
  },
  {
    header: "Delivery Cartage \n(Door Delivery)",
    field: "DeliveryCartage",
    xlCol: xlColq,
    weight: 66,
  },
  {
    header: "Hire Charges",
    field: "HireCharges",
    xlCol: xlColq,
    weight: 49,
  },
  { header: "TDS", field: "TDS", xlCol: xlColq, weight: 40 },
  {
    header: "Amount Received",
    field: "AmountReceived",
    xlCol: xlColq,
    weight: 66,
  },
  {
    header: "Final \nOutstanding \nReceivable",
    field: "FinalReceiveable",
    xlCol: xlColq,
    weight: 69,
  },
  { header: "Edit", field: "edit_view", xlCol: xlCol, ViewOnly: true, weight: 35 },
];
export const BranchDueDetailedHeaders = [
  { header: "SN", field: "SN", xlCol: xlCol, weight: 23 },
  { header: "Transaction Date", field: "TransDateView", xlCol: xlCol, weight: 80 },
  { header: "LR / GC No", field: "LRNO", xlCol: xlCol, weight: 90 },
  { header: "Origin City", field: "OriginCity", xlCol: xlCol, weight: 100 },
  { header: "Destination City", field: "DestinationCity", xlCol: xlCol, weight: 100 },
  { header: "Vehicle No", field: "VehicleNo", xlCol: xlCol, weight: 85 },
  { header: "Payment Type", field: "PaymentType", xlCol: xlCol, weight: 80 },
  { header: "Total Units", field: "Items", xlCol: xlColq, weight: 54 },
  {
    header: "Only Freight Amount",
    field: "Freight",
    xlCol: xlColq,
    weight: 65,
  },
  {
    header: "Other Charges (Incl. Cartage)",
    field: "OtherCharges",
    xlCol: xlColq,
    weight: 70,
  },
  {
    header: "Total Gross Amount",
    field: "GrossAmount",
    xlCol: xlColq,
    weight: 65,
  },
  {
    header: "Paid Amount",
    field: "PaidAmt",
    xlCol: xlColq,
    weight: 60,
  },
  {
    header: "ToPay Amount",
    field: "TopayAmt",
    xlCol: xlColq,
    weight: 60,
  },
  {
    header: "On-Account Amount",
    field: "OnAccountAmt",
    xlCol: xlColq,
    weight: 65,
  },
  {
    header: "Booking Commission",
    field: "BookingCommission",
    xlCol: xlColq,
    weight: 60,
  },
  {
    header: "Delivery Commission",
    field: "DeliveryCommission",
    xlCol: xlColq,
    weight: 60,
  },
  { header: "TDS", field: "TDS", xlCol: xlColq, weight: 40 },
  {
    header: "Net Amount",
    field: "NetAmount",
    xlCol: xlColq,
    weight: 65,
  },
];
export const BranchPayableHeaders = [
  { header: "SN", field: "SN", xlCol: xlCol, weight: 10 },
  { header: "Date", field: "TransDate", xlCol: xlCol, weight: 20 },
  { header: "Expense Perticulars", field: "ExpenseHeader", xlCol: xlCol, weight: 50 },
  { header: "Payment Cycle", field: "PaymentCycleName", xlCol: xlCol, weight: 25 },
  { header: "Expense Type", field: "ExpenseTypeName", xlCol: xlCol, weight: 20 },
  {
    header: "Previous\nOutstanding\nBalance",
    field: "OpeningBalance",
    xlCol: xlColq,
    weight: 25
  },
  {
    header: "Today's\nExpense",
    field: "ExpenseAmt_view",
    xlCol: xlColq,
    weight: 25
  },
  {
    header: "Payment\nMade",
    field: "PaymentAmt_view",
    xlCol: xlColq,
    weight: 25
  },
  {
    header: "Final\nOutstanding\nBalance",
    field: "FinalOutstanding",
    xlCol: xlColq,
    weight: 25
  },
  {
    header: "Remarks",
    field: "Remarks_view",
    xlCol,
    weight: 35
  },
  { header: "Edit", field: "edit_view", xlCol: xlCol, ViewOnly: true, weight: 15 },
];
export const ExpenseMasterHeaders = [
  { header: "SN", field: "SN", xlCol: xlCol, weight: 10 },
  {
    header: "Payment Perticulars",
    field: "ExpenseHeader",
    xlCol: xlCol,
    weight: 60,
  },
  {
    header: "Payment Cycle",
    field: "PaymentCycleName",
    xlCol: xlCol,
    weight: 25,
  },
  {
    header: "Txn Type",
    field: "TransactionType",
    xlCol: xlCol,
    weight: 20,
  },
  {
    header: "Expense Type",
    field: "ExpenseTypeName",
    xlCol: xlCol,
    weight: 25,
  },
  {
    header: "Amount",
    field: "Amount",
    xlCol: xlColq,
    weight: 20,
    align: "right",
  },
  {
    header: "Edit",
    field: "edit_view",
    xlCol: xlCol,
    ViewOnly: true,
    weight: 10,
    align: "center",
  },
];
export const BookingSummaryHeaders = [
  { header: "SN", field: "SN", xlCol: xlCol, weight: 30, isSortIcon: false },
  { header: "Date", field: "BookingDate", xlCol: xlCol, weight: 70, isSortIcon: true },
  { header: "Branch State", field: "StateName", xlCol: xlCol, weight: 70, isSortIcon: true },
  { header: "Branch City", field: "SourceCityName", xlCol: xlCol, weight: 80, isSortIcon: true },
  { header: "Branch Name", field: "SourceBranchName", xlCol: xlCol, weight: 120, isSortIcon: true },
  {
    header: "Total No\nof LRs",
    field: "TotalLR",
    xlCol: xlColq,
    weight: 60, isSortIcon: true
  },

  {
    header: "Total No\nof Units",
    field: "TotalQty",
    xlCol: xlColq,
    weight: 70, isSortIcon: true
  },

  {
    header: "Total Freight\nAmount",
    field: "TotalFreight",
    xlCol: xlColq,
    weight: 80, isSortIcon: true
  },

  {
    header: "Other Charges\n(Incl GST)",
    field: "OtherChargesTotal",
    xlCol: xlColq,
    weight: 80, isSortIcon: true
  },

  {
    header: "Paid\nAmount",
    field: "PaidAmount",
    xlCol: xlColq,
    weight: 70, isSortIcon: true
  },

  {
    header: "To Pay\nAmount",
    field: "ToPayAmount",
    xlCol: xlColq,
    weight: 80, isSortIcon: true
  },

  {
    header: "On Account\nAmount",
    field: "OnAccountAmount",
    xlCol: xlColq,
    weight: 80, isSortIcon: true
  },

  {
    header: "Total\nAmount",
    field: "TotalAmount",
    xlCol: xlColq,
    weight: 80, isSortIcon: true
  },

  {
    header: "GST @ 5%\non Total Amount",
    field: "GSTAmount",
    xlCol: xlColq,
    weight: 90, isSortIcon: true
  },

  {
    header: "Admin Cost\n@ 20% on Total",
    field: "AdminCost",
    xlCol: xlColq,
    weight: 90, isSortIcon: true
  },
];
export const paymentCycles = [
  { id: 1, label: "Day of Month" },
  { id: 2, label: "Daily" },
  { id: 3, label: "Weekly" },
  { id: 4, label: "Fortnightly" },
  { id: 5, label: "Monthly" },
  { id: 6, label: "Half-yearly" },
  { id: 7, label: "Yearly" },
];
export const txnTypes = [
  { id: 1, label: "Fixed" },
  { id: 2, label: "Variable" },
];
export const expenseTypes = [
  { id: 1, label: "Fixed" },
  { id: 2, label: "Variable" },
  { id: 3, label: "Admin" },
  { id: 4, label: "Operational" },
];

export const profitLossHeaders = [
  { header: "SN", field: "SN", xlCol, weight: 8, isSortIcon: false },

  { header: "Dispatch Date", field: "DispatchDate", xlCol, weight: 18, isSortIcon: true },

  { header: "Vehicle No", field: "VehicleNo", xlCol, weight: 20, isSortIcon: true },

  { header: "Origin City", field: "BookingCity", xlCol, weight: 22, isSortIcon: true },

  { header: "Destination City", field: "DestinationCity", xlCol, weight: 22, isSortIcon: true },

  {
    header: "Total Gross Amount",
    field: "GrossAmount",
    xlCol: xlColq,
    weight: 20, isSortIcon: true
  },
  {
    header: "Only Freight Amount",
    field: "Freight",
    xlCol: xlColq,
    weight: 20, isSortIcon: true
  },
  {
    header: "Other Charges (Incl. Cartage)",
    field: "OtherCharges",
    xlCol: xlColq,
    weight: 25, isSortIcon: true
  },
  {
    header: "Hamali Charges",
    field: "HamaliCharge",
    xlCol: xlColq,
    weight: 20, isSortIcon: true
  },
  {
    header: "DP/DD Expense",
    field: "PickupCartage",
    xlCol: xlColq,
    weight: 25, isSortIcon: true
  },
  {
    header: "Booking Commission",
    field: "BookingCommission",
    xlCol: xlColq,
    weight: 22, isSortIcon: true
  },
  {
    header: "Delivery Commission",
    field: "DeliveryCommission",
    xlCol: xlColq,
    weight: 22, isSortIcon: true
  },
  {
    header: "Forwarding Charges",
    field: "ForwardingCharges",
    xlCol: xlColq,
    weight: 28, isSortIcon: true
  },
  {
    header: "Total Net Amount",
    field: "NetAmount",
    xlCol: xlColq,
    weight: 22, isSortIcon: true
  },
];
export const profitLossDummyData = [
  // ===== 01-01-2026 | KA-01-AB-1234 =====
  {
    SN: 1,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-1234",
    OriginCity: "Vishakapatnam",
    DestinationCity: "Bangalore",
    TotalGrossAmount: 100000,
    OnlyFreightAmount: 90000,
    OtherCharges: 10000,
    HamaliCharges: 9000,
    DPDDExpense: 2000,
    BookingCommission: 22500,
    DeliveryCommission: 4500,
    ForwardingCharges: 27000,
    TotalNetAmount: 35000,
    HireCharges: 300,
    TDSAmount: 250,
    GSTAmount: 180,
  },
  {
    SN: 2,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-1234",
    OriginCity: "Vishakapatnam",
    DestinationCity: "Bangalore",
    TotalGrossAmount: 100000,
    OnlyFreightAmount: 90000,
    OtherCharges: 10000,
    HamaliCharges: 9000,
    DPDDExpense: 2000,
    BookingCommission: 22500,
    DeliveryCommission: 4500,
    ForwardingCharges: 27000,
    TotalNetAmount: 35000,
    HireCharges: 300,
    TDSAmount: 250,
    GSTAmount: 180,
  },
  {
    SN: 3,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-1234",
    OriginCity: "Vishakapatnam",
    DestinationCity: "Bangalore",
    TotalGrossAmount: 100000,
    OnlyFreightAmount: 90000,
    OtherCharges: 10000,
    HamaliCharges: 9000,
    DPDDExpense: 2000,
    BookingCommission: 22500,
    DeliveryCommission: 4500,
    ForwardingCharges: 27000,
    TotalNetAmount: 35000,
    HireCharges: 300,
    TDSAmount: 250,
    GSTAmount: 180,
  },
  {
    SN: 4,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-1234",
    OriginCity: "Vishakapatnam",
    DestinationCity: "Bangalore",
    TotalGrossAmount: 80000,
    OnlyFreightAmount: 72000,
    OtherCharges: 8000,
    HamaliCharges: 7200,
    DPDDExpense: 1600,
    BookingCommission: 18000,
    DeliveryCommission: 3600,
    ForwardingCharges: 21600,
    TotalNetAmount: 28000,
    HireCharges: 325,
    TDSAmount: 250,
    GSTAmount: 200,
  },

  // ===== 01-01-2026 | KA-01-AB-2345 =====
  {
    SN: 5,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-2345",
    OriginCity: "Bangalore",
    DestinationCity: "Vishakapatnam",
    TotalGrossAmount: 150000,
    OnlyFreightAmount: 135000,
    OtherCharges: 15000,
    HamaliCharges: 13500,
    DPDDExpense: 3000,
    BookingCommission: 33750,
    DeliveryCommission: 6750,
    ForwardingCharges: 45000,
    TotalNetAmount: 48000,
    HireCharges: 325,
    TDSAmount: 250,
    GSTAmount: 190,
  },
  {
    SN: 6,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-2345",
    OriginCity: "Bangalore",
    DestinationCity: "Vishakapatnam",
    TotalGrossAmount: 150000,
    OnlyFreightAmount: 135000,
    OtherCharges: 15000,
    HamaliCharges: 13500,
    DPDDExpense: 3000,
    BookingCommission: 33750,
    DeliveryCommission: 6750,
    ForwardingCharges: 45000,
    TotalNetAmount: 48000,
    HireCharges: 325,
    TDSAmount: 250,
    GSTAmount: 190,
  },
  {
    SN: 7,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-2345",
    OriginCity: "Bangalore",
    DestinationCity: "Vishakapatnam",
    TotalGrossAmount: 150000,
    OnlyFreightAmount: 135000,
    OtherCharges: 15000,
    HamaliCharges: 13500,
    DPDDExpense: 3000,
    BookingCommission: 33750,
    DeliveryCommission: 6750,
    ForwardingCharges: 45000,
    TotalNetAmount: 48000,
    HireCharges: 300,
    TDSAmount: 250,
    GSTAmount: 190,
  },
  {
    SN: 8,
    DispatchDate: "01-01-2026",
    VehicleNo: "KA-01-AB-2345",
    OriginCity: "Bangalore",
    DestinationCity: "Vishakapatnam",
    TotalGrossAmount: 150000,
    OnlyFreightAmount: 135000,
    OtherCharges: 15000,
    HamaliCharges: 13500,
    DPDDExpense: 3000,
    BookingCommission: 33750,
    DeliveryCommission: 6750,
    ForwardingCharges: 45000,
    TotalNetAmount: 48000,
    HireCharges: 325,
    TDSAmount: 250,
    GSTAmount: 190,
  },

  // ===== 02-01-2026 =====
  {
    SN: 9,
    DispatchDate: "02-01-2026",
    VehicleNo: "KA-01-AB-1234",
    OriginCity: "Vishakapatnam",
    DestinationCity: "Bangalore",
    TotalGrossAmount: 100000,
    OnlyFreightAmount: 90000,
    OtherCharges: 10000,
    HamaliCharges: 9000,
    DPDDExpense: 2000,
    BookingCommission: 22500,
    DeliveryCommission: 4500,
    ForwardingCharges: 27000,
    TotalNetAmount: 35000,
    HireCharges: 1300,
    TDSAmount: 1050,
    GSTAmount: 700,
  },
  {
    SN: 10,
    DispatchDate: "02-01-2026",
    VehicleNo: "KA-01-AB-1234",
    OriginCity: "Vishakapatnam",
    DestinationCity: "Bangalore",
    TotalGrossAmount: 80000,
    OnlyFreightAmount: 72000,
    OtherCharges: 8000,
    HamaliCharges: 7200,
    DPDDExpense: 1600,
    BookingCommission: 18000,
    DeliveryCommission: 3600,
    ForwardingCharges: 21600,
    TotalNetAmount: 28000,
    HireCharges: 1300,
    TDSAmount: 1050,
    GSTAmount: 700,
  },
];

export const OGPLHeaders = [
  { id: 0,header: "SN", export: "SN", field: "SN", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 30, isSortIcon: false },
  { id: 1,header: "LR No\nMan. LR No", export:'LR No\nMan. LR No', field: "LRNO^^ManualLR", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 90, isSortIcon: true },
  { id: 2,header: "Dispatch\nChallan No", export:'Dispatch\nChallan No', field: "VoucherNo", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 70, isSortIcon: true },
  { id: 3,header: "Dispatch Date", export:'Dispatch Date', field: "DispatchDateTime", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 80, isSortIcon: true },
  { id: 4,header: "Origin City\nOrigin Branch", export:'Origin City\nOrigin Branch', field: "BookCity^^SourceBranchName", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 150, isSortIcon: true },
  { id: 5,header: "Dest. City\nDest. Branch", export:'Dest. City\nDest. Branch', field: "ToCity^^DestinationBranchName", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 150, isSortIcon: true },
  { id: 6,header: "Consignor Name\nConsignee No", export:'Consignor Name\nConsignee No', field: "Sender^^SenderMobileNo", xlCol: xlCol,isSelected: true, isDefault: false, isMandatory: false, weight: 120, isSortIcon: true },
  { id: 7,header: "Consignee Name\nConsignor No", export:'Consignee Name\nConsignor No', field: "RecName^^RecMobileNo", xlCol: xlCol,isSelected: true, isDefault: false, isMandatory: false, weight: 100, isSortIcon: true },
  { id: 8,header: "Vehicle Number", export:'Vehicle Number', field: "VehicleNo", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 80, isSortIcon: true },
  { id: 9,header: "Pymt. Type.", export:'Pymt. Type.', field: "PaymentType", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 70, isSortIcon: true },
  { id: 10,header: "Booked By User", export:'Booked By User', field: "BookedBy", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 80, isSortIcon: true },
  { id: 11,header: "Booked On Date", export:'Booked On Date', field: "BookingDateTime", xlCol: xlCol,isSelected: true, isDefault: true, isMandatory: true, weight: 80, isSortIcon: true },
  { id: 12,header: "Total Unitst", export:'Total Units', field:"Quantity", xlCol :xlColq ,isSelected:true ,isDefault:true ,isMandatory:true ,weight :90, isSortIcon: true },
  { id: 13,header: "Only Freight Amount", export:'Only Freight Amount', field:"Freight", xlCol :xlColq ,isSelected:true ,isDefault:true ,isMandatory:true ,weight :90, isSortIcon: true },
  { id: 14,header: "Other Charges (Incl. All)", export:'Other Charges (Incl. All)', field: "TotalBookingOtherCharges", xlCol: xlColq,isSelected: true, isDefault: true, isMandatory: true, weight: 90, isSortIcon: true },
  { id: 15,header: "Pickup Cart./ Handling", export:'Pickup Cart./ Handling', field: "PickupCartage", xlCol: xlColq,isSelected: true, isDefault: true, isMandatory: true, weight: 90, isSortIcon: true },
  { id: 16,header: "Delivery Cart./ Handling", export:'Delivery Cart./ Handling', field: "CartageDeliveryAmount", xlCol: xlColq,isSelected: true, isDefault: true, isMandatory: true, weight: 90, isSortIcon: true },
  { id: 17,header: "Paid Amount", export:'Paid Amount', field:"PaidBookingNetAmount", xlCol :xlColq ,isSelected:true ,isDefault:true ,isMandatory:true ,weight :90, isSortIcon: true },
  { id: 18,header: "ToPay Amount", export:'ToPay Amount', field:"ToPayBookingNetAmount", xlCol :xlColq ,isSelected:true ,isDefault:true ,isMandatory:true ,weight :90, isSortIcon: true },
  { id: 19,header: "On-Account Amount", export:'On-Account Amount', field:"OnAccountBookingNetAmount", xlCol :xlColq ,isSelected:true ,isDefault:true ,isMandatory:true ,weight :90, isSortIcon: true },
];
export const PGPLFilterHeaders = [
  { field: 'fromDate', header: 'From  Date', textAlign: 'left' },
  { field: 'toDate', header: 'To  Date', textAlign: 'left' },
  { field: 'selState', header: 'Source State', textAlign: 'left' },
  { field: 'selCity', header: 'Source City', textAlign: 'left' },
  { field: 'selBranch', header: 'Source Branch', textAlign: 'left' },
  { field: 'selDestState', header: 'Destination State', textAlign: 'left' },
  { field: 'selDestCity', header: 'Destination City', textAlign: 'left' },
  { field: 'selDestBranch', header: 'Destination Branch', textAlign: 'left' },
  { field: 'selPaymentType', header: 'Payment Type', textAlign: 'left' },
]
export const OGCLHeaders = [
  { id: 0,header: "SN", export: "SN", field: "SN", xlCol: xlCol, weight: 30, isSortIcon: false },
  { id: 1,header: "Dispatch Date", export:'Dispatch Date', field: "DispatchDate", xlCol: xlCol, weight: 90, isSortIcon: true },
  { id: 2,header: "Disp.\nChallan No", export:'Disp.\nChallan No', field: "VoucherNo", xlCol: xlCol, weight: 70, isSortIcon: true },
  { id: 3,header: "Origin City", export:'Origin City', field: "BookingCity", xlCol: xlCol, weight: 80, isSortIcon: true },
  { id: 4,header: "Destination City", export:'Destination City', field: "ToCity", xlCol: xlCol, weight: 120, isSortIcon: true},
  { id: 5,header: "Total Units", export:'Total Units', field: "Quantity", xlCol: xlColq, weight: 80, isSortIcon: true },
  { id: 6,header: "Paid Amount", export:'Paid Amount', field: "PaidAmount", xlCol: xlColq, weight: 120, isSortIcon: true },
  { id: 7,header: "ToPay Amount", export:'ToPay Amount', field: "ToPayAmount", xlCol: xlColq, weight: 100 , isSortIcon: true},
  { id: 8,header: "On-Account\nAmount", export:'On-Account\nAmount', field: "OnAccountAmount", xlCol: xlColq, weight: 80, isSortIcon: true },
  { id: 9,header: "Only Freight\nAmount", export:'Only Freight\nAmount', field: "Freight", xlCol: xlColq, weight: 70, isSortIcon: true },
  { id: 10,header: "Other Charges\n(Incl. Cartage)", export:'Other Charges\n(Incl. Cartage)', field: "OtherCharges", xlCol: xlColq, weight: 80, isSortIcon: true },
  { id: 11,header: "Total Gross\nAmount", export:'Total Gross\nAmount', field: "NetAmount", xlCol: xlColq, weight: 80, isSortIcon: true },
  { id: 12,header: "Booking\nCommission", export:'Booking\nCommission', field:"FreightComm", xlCol :xlColq ,weight :90, isSortIcon: true },
  { id: 13,header: "Pickup Cart./ Handling", export:'Pickup Cart./ Handling', field:"PickupCartage", xlCol :xlColq ,weight :90, isSortIcon: true },
  { id: 14,header: "Delivery\nCommission", export:'Delivery\nCommission', field: "DeliveryComm", xlCol: xlColq, weight: 90 , isSortIcon: true},
  { id: 15,header: "Delivery Cart./ Handling", export:'Delivery Cart./ Handling', field: "CartageDelivery", xlCol: xlColq, weight: 90, isSortIcon: true },
  { id: 16,header: "TDS", export:'TDS', field: "TDS", xlCol: xlColq, weight: 90, isSortIcon: true },
  { id: 17,header: "GST", export:'GST', field:"GST", xlCol :xlColq ,weight :90, isSortIcon: true },
  { id: 17,header: "Net Balance", export:'Net Balance', field:"NetBalance", xlCol :xlColq ,weight :90, isSortIcon: true },
];
export const OGCLFilterHeaders = [
  { field: 'fromDate', header: 'From  Date', textAlign: 'left' },
  { field: 'toDate', header: 'To  Date', textAlign: 'left' },
  { field: 'selState', header: 'Source State', textAlign: 'left' },
  { field: 'selCity', header: 'Source City', textAlign: 'left' },
  { field: 'selBranch', header: 'Source Branch', textAlign: 'left' },
  { field: 'selDestState', header: 'Destination State', textAlign: 'left' },
  { field: 'selDestCity', header: 'Destination City', textAlign: 'left' },
  { field: 'selDestBranch', header: 'Destination Branch', textAlign: 'left' },
  { field: 'selPaymentType', header: 'Payment Type', textAlign: 'left' },
]
export const GSTReportv1Headers = [
  { id: 0,header: "SN", export: "SN", field: "SN", xlCol: xlCol, weight: 30, isSortIcon: false },
  { id: 1,header: "LR NO", export:'LR NO', field: "LRNO", xlCol: xlCol, weight: 90, isSortIcon: true },
  { id: 17,header: "Invoice No", export:'Invoice No', field: "invoiceno", xlCol: xlCol, weight: 90, isSortIcon: true },
  { id: 2,header: "Date of\nBilty", export:'Date of\nBilty', field: "TransDate", xlCol: xlCol, weight: 120, isSortIcon: true },
  { id: 18,header: "Source State", export:'Source State', field: "statename", xlCol: xlCol, weight: 80, isSortIcon: true },
  { id: 3,header: "Place of Suply", export:'Place of Suply', field: "PlaceOfSupply", xlCol: xlCol, weight: 80, isSortIcon: true },
  { id: 4,header: "RCM", export:'RCM', field: "IsRCM", xlCol: xlCol, weight: 120, isSortIcon: true },
  { id: 5,header: "Name of\nSender", export:'Name of\nSender', field: "Sender", xlCol: xlCol, weight: 80, isSortIcon: true },
  { id: 6,header: "GSTIN of\nSender", export:'GSTIN of\nSender', field: "SenderGSTN", xlCol: xlCol, weight: 120, isSortIcon: true },
  { id: 7,header: "Name of\nReceiver", export:'Name of\nReceiver', field: "RecName", xlCol: xlCol, weight: 100, isSortIcon: true },
  { id: 8,header: "GSTIN of\nReceiver", export:'GSTIN of\nReceiver', field: "ReceiverGSTN", xlCol: xlCol, weight: 80, isSortIcon: true },
  { id: 9,header: "Bilty\nType", export:'Bilty\nType', field: "paymenttype", xlCol: xlColq, weight: 70, isSortIcon: true },
  { id: 10,header: "Rate of\nGST", export:'Rate of\nGST', field: "GSTRate", xlCol: xlColq, weight: 80, isSortIcon: true },
  { id: 11,header: "Taxable\nAmount", export:'Taxable\nAmount', field: "TaxableAmt", xlCol: xlColq, weight: 80, isSortIcon: true },
  { id: 12,header: "IGST", export:'IGST', field:"IGST", xlCol :xlColq ,weight :90, isSortIcon: true },
  { id: 13,header: "CGST", export:'CGST', field:"CGST", xlCol :xlColq ,weight :90, isSortIcon: true },
  { id: 14,header: "SGST", export:'SGST', field: "SGST", xlCol: xlColq, weight: 90, isSortIcon: true },
  { id: 15,header: "Invoice Value", export:'Invoice Value', field: "BillingAmount", xlCol: xlColq, weight: 90, isSortIcon: true },
  { id: 16,header: "GST Liability", export:'GST Liability', field: "GSTLiability", xlCol: xlCol, weight: 90, isSortIcon: true },
];
export const GSTReportv1FilterHeaders = [
  { field: 'fromDate', header: 'From  Date', textAlign: 'left' },
  { field: 'toDate', header: 'To  Date', textAlign: 'left' },
  { field: 'stateName', header: 'Source State', textAlign: 'left' },
  { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
  { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
  { field: 'destCity', header: 'Destination City', textAlign: 'left' },
  { field: 'destBranch', header: 'Destination Branch', textAlign: 'left' },
  { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
  { field: 'gstPaidBy', header: 'GST Paid By', textAlign: 'left' },
  { field: 'bookingType', header: 'Booking Type', textAlign: 'left' },
]
